import { useCallback, useEffect, useState } from 'react';
import { useThreadStateRealtime } from '@/components/activity/useThreadStateRealtime';
import { type AppNextActionsView, readAppNextActions } from '@/lib/app-record-actions';

/** N2: the first next action of each object of the app, kept live with the app's work. */
export const useAppNextActions = (flowId: string | null | undefined) => {
  const [view, setView] = useState<AppNextActionsView | null>(null);
  const reload = useCallback(() => {
    if (!flowId) return;
    void readAppNextActions(flowId).then(setView)
      .catch((cause) => console.error('app_next_actions_load_failed', cause));
  }, [flowId]);
  useEffect(() => { reload(); }, [reload]);
  useThreadStateRealtime({ enabled: Boolean(view?.threadId), threadId: view?.threadId ?? null, onRefresh: reload });
  return view?.byRecord ?? null;
};
